<script>
import Button from "@/components/atoms/button";
import DropDown from "@/components/molecules/drop-down";
import DropDownItem from "@/components/molecules/drop-down/drop-down-item";
import { productDetailsMultipay } from "./mixin";

export default {
  name: "ProductDetailsMultipay",
  components: {
    Button,
    DropDown,
    DropDownItem
  },
  props: {
    ...productDetailsMultipay()
  },
  emits: ["changeCodeSimulateur", "openPopin"]
};
</script>

<template>
  <div class="u-text-right u-mt-xs25">
    <div class="c-product-detail__multipay">
      <div class="u-flex u-flex-align-baseline u-mb-xs u-color-text-light">
        OU
        <DropDown
          v-if="cbx3 && cbx4"
          ref="dropdown"
          radius="sm"
          size="xxs"
          icon-color="white"
          multipay
          class="u-mx-xs"
        >
          <template #button-content>
            <span>
              {{ nbMensualites }}
            </span>
          </template>
          <DropDownItem>
            <Button
              variant="text"
              class="u-my-xs"
              @click="$emit('changeCodeSimulateur', cbx3.attributes.code_paiement_simulateur)"
            >
              3
            </Button>
          </DropDownItem>
          <DropDownItem>
            <Button
              variant="text"
              class="u-my-xs"
              @click="$emit('changeCodeSimulateur', cbx4.attributes.code_paiement_simulateur)"
            >
              4
            </Button>
          </DropDownItem>
        </DropDown>
        <span
          v-else
          class="u-font-20 u-color-text u-font-700 u-mx-xs"
        >
          {{ nbMensualites }}&nbsp;x
        </span>
        <span class="u-font-20 u-font-700 u-color-secondary">
          <template v-if="cbx3 && cbx4">x</template>
          {{ formatPrix(mensualites) }} €
        </span>
      </div>
      <p
        v-if="frais"
        class="u-mt-xxs u-font-14"
      >
        + {{ formatPrix(frais) }} € de frais de dossier
      </p>
      <Button
        link
        variant="text-light"
        class="u-mt-xxs"
        @click="$emit('openPopin')"
      >
        Réglez en {{ nbMensualites }} fois {{ frais ? "avec" : "sans" }} frais
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-product-detail__multipay {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 1.6rem 1.2rem;
  border: 1px solid #e9e9e9;
  border-radius: 0.8rem;
  font-size: 1.4rem;
  > div:first-child {
    display: flex;
    margin-bottom: spacing(xs);
    color: color(text-light);
  }
}
</style>
